import { render, staticRenderFns } from "./MessageSignatureMissingAlert.vue?vue&type=template&id=2df70ca5&"
import script from "./MessageSignatureMissingAlert.vue?vue&type=script&lang=js&"
export * from "./MessageSignatureMissingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports